import React from 'react';
import MyAccount from '../../components/feature/my-account';
import withLayout from '../../components/layout/index';

const Account = () => {
    return (
        <MyAccount />
    );
};

export default withLayout(Account, false, true);
